<template>
<div class="card">
    <div class="card-header">Roster with Manager/Interview</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
        
        <div v-if="hiringManagerOrSubmitter">
            <BaseStatusHelp lifecycleStatus="10"/>

            <b-form @submit.stop.prevent="onSubmit">
                <b-row>
                    <b-col>
                        <LifecycleCheckList lifecycleStatus="10" :requestId="request.id"
                            v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                    </b-col>
                </b-row> 

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextInput v-model="request.selectedCandidateName"
                                        :v="$v.request.selectedCandidateName"
                                        label="Selected Candidate Name"
                                        tip=""
                                        slug="candidateName"
                                        :required="$v.request.selectedCandidateName.$params.required"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextInput v-model="request.selectedCandidateEmail"
                                        :v="$v.request.selectedCandidateEmail"
                                        label="Selected Candidate Email"
                                        tip=""
                                        slug="candidateEmail"
                                        :required="$v.request.selectedCandidateEmail.$params.required"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextInput v-model="request.selectedCandidateEmployeeId"
                                        :v="$v.request.selectedCandidateEmployeeId"
                                        label="Selected Candidate Employee ID"
                                        tip=""
                                        slug="candidateEmpId"
                                        :required="$v.request.selectedCandidateEmployeeId.$params.required"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <BaseParagraphInput v-model="request.interviewComments"
                            :v="$v.request.interviewComments" 
                            slug="interviewComments"
                            label="Manager Interview Comments"/>
                    </b-col>
                </b-row>
                
                <div>
                    <b-button type="submit" variant="primary">Complete Roster with Manager/Interview</b-button>
                    <b-button type="button" variant="outline-primary" @click="backToScreening">Back to Screening</b-button>
                    <b-button type="button" variant="outline-primary" @click="save">Save</b-button>
                </div>
            </b-form>
        </div>
         <div v-else>
            <b-col cols="12">
                <b-alert show>This request is currently being reviewed by the Requester.  Please wait their response.</b-alert>
            </b-col>
        </div>

    </div>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric, requiredUnless } from 'vuelidate/lib/validators'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'
import _ from "lodash"

export default {
    components: {
        LifecycleCheckList,
    },
    props: {
        request: Object
    },
    data() {
        return { 
            checklistComplete: false,
            comments: '',
            saveOnly: false,
            hiringManagerOrSubmitter: false,
        }
    },
    created() {
        this.hiringManagerOrSubmitter = (this.request.supervisor && this.request.supervisor.userId &&
                                         this.request.supervisor.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()) ||
                                         (this.request.submitter && this.request.submitter.userId &&
                                         this.request.submitter.userId.toLowerCase() === this.$keycloak.userName.toLowerCase())
     },
     validations() {
         return {
            comments: { required: false, maxLength: maxLength(4000) },
            checklistComplete: { checked: value => value === true },
            request: { 
                interviewComments: { required: false, maxLength: maxLength(4000) },
                selectedCandidateEmail: { maxLength: maxLength(75),
                    required
                 },
                selectedCandidateName: { maxLength: maxLength(75),
                    required
                 },
                selectedCandidateEmployeeId: { required: false, maxLength: maxLength(75) }
            }
         }
     },
    methods: {
        updateChecklistStatus(b) {
            this.checklistComplete = b
        },

        save() {
            this.saveOnly = true
            this.onSubmit()
            this.saveOnly = false
        },

        onSubmit() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                comments: this.request.interviewComments,
                selectedCandidateEmail: this.request.selectedCandidateEmail,
                selectedCandidateName: this.request.selectedCandidateName,
                selectedCandidateEmployeeId: this.request.selectedCandidateEmployeeId,
                nextLifecycle: '16',
                advanceNextLifecycle: !this.saveOnly,
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/managerInterview`, payload)
                  .then(response => {                       
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    if (payload.advanceNextLifecycle === true) {
                        this.$router.push('/home')
                    } 
                  })
                  
        },

        backToScreening() {
            let payload = {
                requestId: this.request.id,
                advanceNextLifecycle: !this.saveOnly
            }
        
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/manager/return/specialist`, payload)
              .then(response => {
                this.showRootToast("HRM Request Has Been Sent to HRM Specialist", "Success", "success")
                this.$router.push('/home')
              })
        },

        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
    }   
}
</script>